// Create Store product-template picker — catalog / brand lineups only.
// Sport artwork (sport-football, …) is a separate picker on the same step.
// One-off school clones like "Football — JWP helmet pin" are not offered.

import {
  isProductTemplate,
  isSchoolCloneTemplate,
  type TemplateLike,
} from './store-template-kinds';

export type CreateStoreTemplate = TemplateLike & {
  styleCount?: number;
  brands?: string[];
  brandTag?: string;
};

export { isSchoolCloneTemplate };

export function isCreateStoreProductTemplate(t: CreateStoreTemplate): boolean {
  return isProductTemplate(t);
}

export function sortCreateStoreTemplates(templates: CreateStoreTemplate[]): CreateStoreTemplate[] {
  return templates.filter(isCreateStoreProductTemplate).sort((a, b) => {
    if (a.id === 'general') return -1;
    if (b.id === 'general') return 1;
    return String(a.name || a.id).localeCompare(String(b.name || b.id));
  });
}
